import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconChart_24 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M2.625 21.375H21.375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 15.5417H4.5C4.33491 15.5439 4.17719 15.6104 4.06044 15.7272C3.9437 15.8439 3.87716 16.0017 3.875 16.1667V21.3751H7.625V16.1667C7.62284 16.0017 7.5563 15.8439 7.43956 15.7272C7.32281 15.6104 7.16509 15.5439 7 15.5417Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.25 12.2083H10.75C10.5849 12.2104 10.4272 12.277 10.3104 12.3937C10.1937 12.5104 10.1272 12.6682 10.125 12.8333V21.3749H13.875V12.8333C13.8728 12.6682 13.8063 12.5104 13.6896 12.3937C13.5728 12.277 13.4151 12.2104 13.25 12.2083Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 8.875H17C16.8349 8.87716 16.6772 8.9437 16.5604 9.06045C16.4437 9.17719 16.3772 9.33491 16.375 9.5V21.375H20.125V9.5C20.1228 9.33491 20.0563 9.17719 19.9396 9.06045C19.8228 8.9437 19.6651 8.87716 19.5 8.875Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.48242 9.70003L18.8741 3.6167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8829 6.275L18.8746 3.61667L16.2246 2.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconChart_24.displayName = 'IconChart_24';
